import React, {useLayoutEffect, useState} from 'react';
import {addNotification} from '../../../redux/actions/snackbar';
import {useModal, ModalMethods} from '../../../shared/components/modal';
import {useNavigation} from '@react-navigation/native';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';
import {EsiaRegCardFlowHandler} from './components/form/desktop';
import {Screens} from '../../../shared/routing';
import {loginSlice} from '../../../redux/reducers/login';
import {loginStepSlice} from '../../../redux/reducers/runtime/loginStep';
import {LoginState} from '../../../shared/models/login/loginStep';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../redux';
import {
  cardApplicationIsExpired,
  esiaRegistrationInfoSelector,
  esiaUserHasNoCardsSelector,
} from '../../../redux/selectors/login';
import {useIsDesktop} from '../../../shared/hooks/useIsDesktop';
import {useRegCardState} from './esiaRegCardState/useRegCardState';
import {hideGlobalLoader} from '../../../shared/utils/globalLoader';
import View from './view';

export const EsiaRegCard = () => {
  const isDesktopSize = useIsDesktop();
  const [isEsiaProcessingAccepted, setIsEsiaProcessingAccepted] = useState(false);
  const userHasNoCards = useSelector(esiaUserHasNoCardsSelector);
  const dispatch = useAppDispatch();
  const navigation = useNavigation();
  const modals = useModal();
  const esiaRegInfo = useSelector(esiaRegistrationInfoSelector);
  const {addData} = useRegCardState();
  const applicationIsExpired = useSelector(cardApplicationIsExpired);
  const showModal = React.useCallback(
    ({replace = false}: {replace?: boolean} = {}) => {
      if (isDesktopSize) {
        const modal = {
          render(modalItem: {id: string}, methods: ModalMethods) {
            const closeRegStepComponent = () => {
              dispatch(loginSlice.actions.setEsiaUserHasNoCards(false));
              dispatch(loginStepSlice.actions.setLoginStep(LoginState.enter));
              methods.remove(modalItem.id);
              navigation.navigate(Screens.Login);
            };
            const onClose = () => {
              dispatch(loginSlice.actions.resetEsiaFlow(null));
              closeRegStepComponent();
            };
            return <EsiaRegCardFlowHandler onClose={onClose} />;
          },
        };
        if (replace) {
          modals.replace(modal);
        } else {
          modals.show(modal);
        }
        return;
      }

      if (applicationIsExpired && esiaRegInfo) {
        addData(esiaRegInfo);
        navigation.navigate(Screens.EsiaRegistrationCardMap);

        dispatch(
          addNotification({
            message:
              'Срок резервации вашей карты истек или ранее поданное заявление было отклонено. Пожалуйста, выберите снова способ доставки для повторной подачи заявления на получение карты',
            type: SnackbarNotificationType.Info,
          }),
        );
        return;
      }

      navigation.navigate(userHasNoCards ? Screens.EsiaActivateCard : Screens.EsiaRegistrationCardUserSelecting);
    },
    [modals, userHasNoCards, isDesktopSize, applicationIsExpired, esiaRegInfo, addData, navigation, dispatch],
  );
  const onButtonPress = () => {
    if (!userHasNoCards) {
      showModal();
    }
    dispatch(loginStepSlice.actions.setLoginStep(LoginState.esiaRegCardUsersHandling));
  };

  useLayoutEffect(() => {
    if (!userHasNoCards) return;

    hideGlobalLoader({resetBlockingCalls: true});
    showModal({replace: true});
  }, [userHasNoCards]);

  if (userHasNoCards) return null;

  return (
    <View
      isEsiaProcessingAccepted={isEsiaProcessingAccepted}
      setIsEsiaProcessingAccepted={setIsEsiaProcessingAccepted}
      onButtonPress={onButtonPress}
    />
  );
};
